import React from 'react';

import classnames from 'classnames';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import FormattedCurrency from '../../../../../components/formatted-currency';
import { useOrderSourceLimitForCurrentBillingPlan } from '../../hooks/use-plan-details';

import messages from './messages';

import styles from './style.module.less';

/**
 * @typedef {import('../../../../../prop-types/currency').Currency} Currency
 */

/**
 * @typedef {import('../../../../../prop-types/subscription-data-types.d.ts').Limit} Limit
 */

/**
 * @param {object} props
 * @param {boolean} props.isShipmentLimitUnlimited
 * @param {number} props.shipmentLimitCount
 * @param {Currency} [props.shipmentLimitPrice]
 * @returns {React.JSX.Element}
 */
export const PlanInfoDetails = ({ isShipmentLimitUnlimited = false, shipmentLimitCount = 0, shipmentLimitPrice }) => {
  const orderSourceLimit = useOrderSourceLimitForCurrentBillingPlan();
  const hasUnlimitedOrderSources = orderSourceLimit === -1;

  const shipmentLimitValue = isShipmentLimitUnlimited ? messages.unlimited : <FormattedNumber value={shipmentLimitCount} />;

  return (
    <>
      <div className={styles['new-info-row']}>
        <div>
          <FormattedMessage {...messages.updatedSellingChannelLimit} />
        </div>
        <div className={styles['multi-info']}>
          {hasUnlimitedOrderSources ? <FormattedMessage {...messages.unlimited} /> : <FormattedNumber value={orderSourceLimit} />}
        </div>
      </div>
      <FlexRow className={classnames(styles['plan-info'], styles['new-info-row'])}>
        <FlexRow className={styles['with-count']}>
          <Text textType={TextType.Paragraph} value={messages.updatedShipmentsPerMonth} />
          <Text className={styles.count} textType={TextType.Paragraph} value={shipmentLimitValue} />
        </FlexRow>
        <div className={styles['plan-info-cost']}>
          {/* We hide the currency and not the outer div to work around `:last-child` logic in `new-info-row` */}
          {shipmentLimitPrice && <FormattedCurrency currencyCode={shipmentLimitPrice.code} value={shipmentLimitPrice.value} />}
        </div>
      </FlexRow>
    </>
  );
};
